import { render, staticRenderFns } from "./MonitorItem.vue?vue&type=template&id=2cab0233&scoped=true"
import script from "./MonitorItem.vue?vue&type=script&lang=js"
export * from "./MonitorItem.vue?vue&type=script&lang=js"
import style0 from "./MonitorItem.vue?vue&type=style&index=0&id=2cab0233&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cab0233",
  null
  
)

export default component.exports